import { queryOptions, useMutation } from "@tanstack/react-query"

import api from "@/utilities/api"

import {
  GatedEmailConfirmationError,
  GatedGetConfirmationDetailsError,
  GatedTextConfirmationError,
} from "@/utilities/expectedErrors"

import { GET_CONFIRMATION_DETAILS_BASE_KEY, SESSION_BASE_KEY } from "./keys"

interface ConfirmationDetailArgs {
  sessionID: string
  confirmationKey: string
}

export const getConfirmationDetailsQueryOptions = (
  args: ConfirmationDetailArgs
) => {
  return queryOptions({
    queryKey: [
      SESSION_BASE_KEY,
      args.sessionID,
      GET_CONFIRMATION_DETAILS_BASE_KEY,
      args.confirmationKey,
    ],
    queryFn: async () => {
      const rsp = await api.getConfirmationDetails.POST({
        sessionID: args.sessionID,
        confirmationKey: args.confirmationKey,
      })
      if ("failReason" in rsp) {
        throw new GatedGetConfirmationDetailsError(rsp.failReason)
      }
      return rsp
    },
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  })
}

export interface SendConfirmationDetailsVariables {
  method: "phone" | "email"
  overwriteContact: boolean
  input: string
}

export const useSendConfirmationDetails = (args: ConfirmationDetailArgs) => {
  return useMutation({
    mutationFn: async (variables: SendConfirmationDetailsVariables) => {
      let rsp
      if (variables.method === "phone") {
        rsp = await api.textConfirmation.POST({
          sessionID: args.sessionID,
          phone: variables.input,
          overwriteContact: variables.overwriteContact,
          confirmationKey: args.confirmationKey,
        })
        if ("failReason" in rsp) {
          throw new GatedTextConfirmationError(rsp.failReason)
        }
      } else {
        rsp = await api.emailConfirmation.POST({
          sessionID: args.sessionID,
          email: variables.input,
          overwriteContact: variables.overwriteContact,
          confirmationKey: args.confirmationKey,
        })
        if ("failReason" in rsp) {
          throw new GatedEmailConfirmationError(rsp.failReason)
        }
      }
      return rsp
    },
  })
}
